import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Product } from '../../shared/models';

@Component({
    selector: 'app-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.scss'],
    standalone: false
})
export class ProductDetailsComponent implements OnInit {
  @Input() selectedProduct: Product;
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    
  }

  close(event: any) {
    event.stopPropagation();
    this.onClose.emit();
  }

}
